import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useQuery } from "react-query";
import { useAppSelector } from "redux/hooks";
import {
  CardData,
  CategoryDef,
  LegendType,
} from "api/interfaces/dashboardInterface.interface";
import ChartWrapper from "../graph/ChartWrapper";
import { useMemo } from "react";
import { getWidgetCovaLicense } from "api/widgetAPI";
import { getLegendForKey } from "utils/StatsUtil";
import { formatNumber } from "utils/functions";

export default function CovaLicense(props: CardData) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const covaLicense = useQuery(
    ["covaLicense", selectedAccount.accountId],
    () => {
      return getWidgetCovaLicense(selectedAccount.accountId);
    },
    {
      retry: 0,
      refetchOnWindowFocus: false,
    }
  );
  const { data, legend } = useMemo(() => {
    if (covaLicense.data) {
      const convertData = getLegendForKey(
        covaLicense.data.result,
        props.items ?? []
      );
      return {
        data: convertData,
        legend: convertData.map((item) => ({
          ...item,
          value: formatNumber(item.value),
        })),
      };
    }
    return {
      data: [],
      legend: [],
    };
  }, [props.items, covaLicense.data]);
  return (
    <ChartWrapper
      rows={data}
      items={props.items as CategoryDef[]}
      legend={legend}
      isLoading={covaLicense.isLoading}
    />
  );
}
